import { render, staticRenderFns } from "./PatologiaCriar.vue?vue&type=template&id=2d8688f6"
import script from "./PatologiaCriar.vue?vue&type=script&lang=js"
export * from "./PatologiaCriar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports